// Wave RW.3 (2026-05-17) — 거래 완료 모달 (실 거래액 만원 단위 입력)
// 백엔드: POST /api/rfq/inquiries/:id/complete { actualAmountKrw } (errorCode: TRADE_AMOUNT_REQUIRED)

import React, { useState } from 'react';

function RFQCompleteModal(props) {
  var onSubmit = props.onSubmit;        // (actualAmountKrw) => Promise
  var onClose = props.onClose;
  var [amountText, setAmountText] = useState('');
  var [submitting, setSubmitting] = useState(false);
  var [err, setErr] = useState('');

  // 만원 단위 입력 — 콤마 자동 포맷, 숫자만 허용
  var onChange = function(e) {
    var raw = (e.target.value || '').replace(/[^\d]/g, '');
    if (!raw) { setAmountText(''); return; }
    setAmountText(Number(raw).toLocaleString());
  };

  var doSubmit = function() {
    setErr('');
    var manwon = parseInt((amountText || '').replace(/[^\d]/g, ''), 10);
    if (!manwon || manwon <= 0) {
      setErr('실 거래액을 만원 단위로 입력해주세요 (예: 5000 = 5,000만원)');
      return;
    }
    setSubmitting(true);
    onSubmit(manwon * 10000)
      .catch(function(e){ setErr((e && e.message) || '오류'); })
      .finally(function(){ setSubmitting(false); });
  };

  return (
    <div onClick={onClose} style={backdrop}>
      <div onClick={function(e){ e.stopPropagation(); }} style={modalBox}>
        <h3 style={{ fontSize: 18, fontWeight: 800, color: '#0f172a', marginBottom: 4 }}>거래 완료 (거래신고)</h3>
        <div style={{ fontSize: 13, color: '#64748b', marginBottom: 18, lineHeight: 1.5 }}>
          실 거래액을 만원 단위로 입력해주세요. 시세 조회 데이터에 반영됩니다.<br/>
          입력값은 거래 자동 생성 (auctions sold) 시 사용됩니다.
        </div>

        <label style={{ fontSize: 13, fontWeight: 600, color: '#475569' }}>실 거래액 (만원)</label>
        <input type="text" value={amountText} onChange={onChange}
          placeholder="5,000"
          autoFocus
          style={{
            width: '100%', boxSizing: 'border-box',
            padding: '10px 12px', fontSize: 16, fontWeight: 700,
            border: '1.5px solid #e2e8f0', borderRadius: 8,
            marginTop: 6, marginBottom: 12,
            fontFamily: "'Pretendard',sans-serif",
            textAlign: 'right',
          }} />

        {amountText && (
          <div style={{ fontSize: 12, color: '#64748b', marginBottom: 14 }}>
            = {(parseInt(amountText.replace(/[^\d]/g, ''), 10) * 10000).toLocaleString()} 원
          </div>
        )}

        {err && (
          <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', color: '#b91c1c', padding: '8px 12px', borderRadius: 8, fontSize: 12, marginBottom: 12 }}>
            {err}
          </div>
        )}

        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button type="button" onClick={onClose} disabled={submitting} style={btnSecondary}>취소</button>
          <button type="button" onClick={doSubmit} disabled={submitting || !amountText} style={btnPrimary(submitting || !amountText)}>
            {submitting ? '처리 중...' : '거래 신고'}
          </button>
        </div>
      </div>
    </div>
  );
}

var backdrop = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  background: 'rgba(15,23,42,0.5)',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  zIndex: 1000, padding: 16,
};
var modalBox = {
  background: 'white', borderRadius: 12,
  padding: 24, width: '100%', maxWidth: 420,
  boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
  fontFamily: "'Pretendard',sans-serif",
};
var btnSecondary = {
  padding: '9px 16px',
  background: 'white', border: '1.5px solid #e2e8f0', borderRadius: 8,
  fontSize: 13, fontWeight: 600, color: '#475569',
  cursor: 'pointer',
  fontFamily: "'Pretendard',sans-serif",
};
function btnPrimary(disabled) {
  return {
    padding: '9px 18px',
    background: disabled ? '#cbd5e1' : '#1B3A5C',
    color: 'white', border: 'none', borderRadius: 8,
    fontSize: 13, fontWeight: 700,
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontFamily: "'Pretendard',sans-serif",
  };
}

export default RFQCompleteModal;
